import { useCreate } from '@refinedev/core';
import { Client } from '../../admin/users/types';

export type CreateClientPayload = {
  emailAddress?: string | null;
  firstName: string;
  lastName: string;
  advisorUserId: string;
  familyId?: string;
};

export function useCreateClient() {
  const { mutateAsync, error, isLoading, reset } = useCreate<Client>();

  const createClient = async (values: CreateClientPayload) => {
    return mutateAsync({
      resource: 'clients',
      values,
    });
  };

  return {
    createClient,
    error,
    isLoading,
    reset,
  };
}
